import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSettlementJournalReport extends Layout {
    excludabletextboxGL: ExcludableTextbox;
    excludabletextboxPayee: ExcludableTextbox;
    settlementDatasource: DataSource;
    switchSort: Switch;
    textboxCurrency: Textbox;
    textboxDateRange: Textbox;
    textboxReportType: Textbox;
}
